<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:fuZhuZy:add')" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="handleFind()" style=";background-color:#409EFF;color: white;">查询<i
                            class="el-icon-search"></i></el-button>
                </div>
                <div style="float: right">
                    <el-input
                            class="queryInput"
                            size="mini"
                            placeholder="请输入查询条件"
                            v-model="markName"
                            clearable>
                    </el-input>
                </div>
            </div>
        </div>
        <el-table :data="tableData" border size="medium" style="width: 100%">
            <el-table-column prop="zy" label="摘要"></el-table-column>
            <el-table-column prop="kjm" label="快捷码"></el-table-column>
            <el-table-column prop="sta" label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.sta=='0'"><span style="color: #35cc5c;">正常</span></span>
                    <span v-if="scope.row.sta=='1'"><span style="color: #f5bb34;">停用</span></span>
                </template>
            </el-table-column>
            <el-table-column label="操作" v-if="$hasPerm('business:fuZhuZy:edit,business:fuZhuZy:remove')">
                <template slot-scope="scope">
                    <el-button size="mini" style="margin-right: 5px;" v-if="$hasPerm('business:fuZhuZy:edit')" @click="handleEdit(scope.$index, scope.row)">编辑<i class="el-icon-edit"></i></el-button>
                    <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.$index, scope.row)">
                        <el-button size="mini" slot="reference" v-if="$hasPerm('business:fuZhuZy:remove')" type="danger">删除<i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 5px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
        ></el-pagination>
        <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
    </div>
</template>
<script>
    import Edit from './edit'

    export default {
        name: 'fuZhuZyList',
        components: {
            Edit
        },
        data() {
            return {
                currentPage: 1, //初始页
                pageSize: 10, //    每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                markName: '',
                editVisible: false
            }
        },
        methods: {
            handleCurrentChange(cPage) {
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuZy/list'),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'markName': this.markName
                    }
                }).then(r => {
                    if (r.data.code == 0) {
                        this.tableData = r.data.data.rows;
                        this.total = r.data.data.total;
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: r.data.msg
                        })
                    }
                })
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            dataFormat: function (row, column) {
                let val = row[column.property];
                if (val == 1) {
                    return '是'
                }
                if (val == 0) {
                    return '否'
                }
                return val;
            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            handleAdd() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int("add");
                })
            },
            handleEdit(index, row) {
                let id = row.id;
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(id);
                })
            },
            handleDelete(index, row) {
                let id = row.id;

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/fuZhuZy/remove'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'id': id
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange(1);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })
            }
        },
        created: function () {
            this.handleCurrentChange(this.currentPage);
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }
</style>